import React, { useEffect, useState } from "react";
import { Card, Table, Spinner, Badge, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Components/Header";

const SolicitudesUsuario = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loadingSolicitudes, setLoadingSolicitudes] = useState(true);
  const userId = localStorage.getItem("id");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchSolicitudes = async () => {
      setLoadingSolicitudes(true);
      try {
        const response = await fetch(
          `https://sectorb12.info/api/solicitudes/usuarios/${userId}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setSolicitudes(data);
        }
      } catch (error) {
        console.error("Error al hacer la solicitud:", error);
      } finally {
        setLoadingSolicitudes(false);
      }
    };
    fetchSolicitudes();
  }, [userId]);

  const formatearEstado = (estado) => {
    const capitalized = estado.charAt(0).toUpperCase() + estado.slice(1).toLowerCase();
    const map = {
      pendiente:   { bg: "light", text: "warning", border: "border-warning" },
      "en proceso": { bg: "light", text: "success", border: "border-success" },
      completada:  { bg: "light", text: "success", border: "border-success" },
      rechazada:   { bg: "light", text: "danger",  border: "border-danger"  },
    };
    const style = map[estado.toLowerCase()] || { bg: "light", text: "secondary", border: "border-secondary" };
    return (
      <Badge bg={style.bg} text={style.text} className={`border ${style.border}`}>
        {capitalized}
      </Badge>
    );
  };

  return (
    <div className="d-flex flex-column">
      <Header />
      <main className="flex-grow-1">
        <Container fluid className="py-3 px-4">
          <Card
            className="border-0 bg-white"
            style={{
              borderRadius: "0.75rem",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}
          >
            <Card.Body className="pb-0">
              <h4 className="mt-1 mb-2">
                <i className="bi bi-file-earmark me-2 text-success"></i>
                Solicitudes presentadas
              </h4>
              <p className="text-muted mb-3">
                En esta sección puede consultar el estado de sus solicitudes a través de la Oficina Virtual.
              </p>
            </Card.Body>

            {loadingSolicitudes ? (
              <Card.Body className="text-center py-5">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
                <p className="mt-3 mb-0">Cargando solicitudes...</p>
              </Card.Body>
            ) : (
              <Card.Body className="pt-2 p-2">
                {solicitudes.length === 0 ? (
                  <p className="text-center text-muted py-4 mb-0">
                    No ha presentado ninguna solicitud.
                  </p>
                ) : (
                  <Table hover responsive className="mb-0 align-middle">
                    <thead>
                      <tr>
                        <th>Nº Registro</th>
                        <th>Descripción</th>
                        <th style={{ width: "220px" }}>Fecha de solicitud</th>
                        <th style={{ width: "160px" }}>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {solicitudes.map((sol) => (
                        <tr key={sol.SolicitudID}>
                          <td>
                            <code className="small text-muted">
                              {sol.NumeroRegistro || "—"}
                            </code>
                          </td>
                          <td className="text-muted">{sol.Descripcion}</td>
                          <td>
                            {new Date(sol.FechaSolicitud).toLocaleDateString("es-ES", {
                              year: "numeric", month: "long", day: "numeric",
                            })}
                          </td>
                          <td>{formatearEstado(sol.Estado)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            )}
          </Card>
        </Container>
      </main>
    </div>
  );
};

export default SolicitudesUsuario;